@if (hasValidationIssues) {
  <button
    class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1 text-sm text-gray-700 hover:bg-gray-200 transition-colors cursor-pointer"
    [pTooltip]="detailedValidationText"
    [tooltipPosition]="tooltipPosition()"
    (click)="handleClick()"
  >
    <i class="pi pi-exclamation-triangle text-gray-600"></i>
    {{ validationSummary }}
  </button>
}
